import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import SplashScreen from 'src/components/loading-screen/splash-screen';
// layouts
import MainLayout from 'src/layouts/main/simpletranslate';

// ----------------------------------------------------------------------
const Trust = lazy(() => import('src/pages/legal/trust'));
const LegalDisclosure = lazy(() => import('src/pages/legal/legal-disclosure'));
const Disclaimer = lazy(() => import('src/pages/legal/disclaimer'));
const EeaStandardContractualClauses = lazy(() => import('src/pages/legal/eeaStandardContractualClauses'));
const CookiePolicy = lazy(() => import('src/pages/legal/cookiePolicy'));
const PrivacyPolicy = lazy(() => import('src/pages/legal/privacyPolicy'));
const DataProcessingAgreement = lazy(() => import('src/pages/legal/dataProcessingAgreement'));
const TermsOfService = lazy(() => import('src/pages/legal/termsOfService'));
const ServiceLevelAgreement = lazy(() => import('src/pages/legal/serviceLevelAgreement'));

// ----------------------------------------------------------------------

export const legalRoutes = [
  {
    element: (
      <MainLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </MainLayout>
    ),
    children: [
      { path: 'trust', element: <Trust /> },
    ],
  },
  {
    path: 'legal',
    element: (
      <MainLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </MainLayout>
    ),
    children: [
      { path: 'legal-disclosure', element: <LegalDisclosure /> },
      { path: 'disclaimer', element: <Disclaimer /> },
      { path: 'eea-standard-contractual-clauses', element: <EeaStandardContractualClauses /> },
      { path: 'cookie-policy', element: <CookiePolicy /> },
      { path: 'privacy-policy', element: <PrivacyPolicy /> },
      { path: 'data-processing-agreement', element: <DataProcessingAgreement /> },
      { path: 'terms-of-service', element: <TermsOfService /> },
      { path: 'service-level-agreement', element: <ServiceLevelAgreement /> },
    ],
  },
];
